export default __webpack_public_path__ + "static/logo-goex-c6ddb15574adf200a65f0cd5e9d9a8be.webp";